const initialState =
{
    data: [],
    saving: false,
    llamadas:[],
    insidencias:[],
};

export default (state = initialState, action) => {
    switch(action.type)
    {
        case 'TICKET_SAVE':
            return {
                ...state,
                saving: true
            }
            
        

        case 'TICKET_SAVE_SUCCESS':
            return {
                ...state,
                saving: false,
                data: [...state.data, action.payload]
            }
             case 'LLAMADA_SAVE_SUCCESS':
            return {
                ...state,
                saving: false,
                llamadas: [...state.llamadas, action.payload]
            }

        case 'TICKET_LIST':
            return {
                ...state,
                data: action.payload
            }
            case 'LLAMADAS_LIST':
            return {
                ...state,
                llamadas: action.payload
            }
        case 'TICKET_UPDATE_SUCCESS':
            return{
                ...state,
                saving : false,
            }
            break;
        case 'TICKET_LIST_INSIDENCIAS':
            return {
                ...state,
                saving: false,
                insidencias:  action.payload
            }
            break;
        case 'UPDATE_SUCCESS_INSIDENCIAS':
            let newp = action.payload;
            return {
                ...state,
                saving: false,
                insidencias: state.insidencias.map((d, i) => { return (d.value == newp.value) ? newp : d })
            }
            break;
            case 'TICKET_UPDATE_FAILURE':
            return{
                ...state,
                saving : false,
            }
            break;

        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/ticket.js